import { useMutation } from '@tanstack/react-query'

import { useAlerts } from '../../theme/hooks/useAlerts'
import { copyAanvraag } from '../services/copyAanvraag'

export { useCopyAanvraag }

const useCopyAanvraag = () => {
  const { successAlert, errorAlert } = useAlerts()

  return useMutation({
    mutationFn: copyAanvraag,
    onSuccess: () => {
      successAlert('Aanvraag succesvol gekopiëerd')
    },
    onError: (error: any) => {
      errorAlert('Fout bij kopiëren aanvraag', error)
    },
  })
}
